// extracted by mini-css-extract-plugin
module.exports = {"arrow":"SortingArrow_arrow__1O4c0","arrowPointingUp":"SortingArrow_arrowPointingUp__2Hh3B"};